import React, { FC, useState } from "react";
import { bind } from "@react-rxjs/core";
import { accessTokenInfo$, isAuthorized$ } from "../../oauth/oauth";
import { useQuery } from "@tanstack/react-query";
import { nodeServer } from "../../constants";
//import { PaginationBase as Pagination } from "../../pagination/Pagination.base";
import {
    DataGrid,
    DataGridRow,
    DataGridHeader,
    DataGridBody,
    DataGridHeaderCell,
    DataGridCell,
    TableColumnDefinition,
    createTableColumn,
    TableCellLayout,
    Text,
    Spinner,
    TableColumnId,
    DataGridCellFocusMode,
    Label,
    useId,
    TableHeader,
    Table,
    TableRow,
    Dropdown,
    Option,
    TableHeaderCell,
    TableBody,
    TableCell,
    Button,
    TableColumnSizingOptions,
} from "@fluentui/react-components";

//import type { SearchBoxProps } from "@fluentui/react-search-preview";
import { useGeneralStyles } from "../../styles";
//import { CheckmarkRegular, DeleteRegular, ArrowUndoRegular } from "@fluentui/react-icons";
import { IConference, IConferenceAttendee, IRegistrationOption, RegistrationOptionType } from "../../conference/conferenceTypes";

interface IProps {}

const [useIsAuthorized] = bind(isAuthorized$, isAuthorized$.value);

const AttendeeData: FC<IProps> = () => {
    const authorized = useIsAuthorized();
    //const queryClient = useQueryClient();

    //const [selected, setSelected] = React.useState(new Set<number>());
    const [updating, setUpdating] = React.useState(false);
    const [searchTerm] = React.useState("");
    // const [searchValue, setSearchValue] = React.useState("");

    const { data: attendeeData, isFetching } = useQuery<{ attendees: IConferenceAttendee[]; conference: IConference }>({
        queryKey: ["membersData", searchTerm],
        refetchOnWindowFocus: false,
        queryFn: async () => {
            setUpdating(true);
            if (accessTokenInfo$.value != null && accessTokenInfo$.value.accessToken != null) {
                let headers = new Headers();
                headers.append("Authorization", "Bearer " + accessTokenInfo$.value.accessToken);
                let url = nodeServer + `conference/attendees`;

                const res = await fetch(url, { headers: headers });
                if (!res.ok) {
                    throw new Error("Network response was not ok");
                }
                const d = await res.json();
                if (d.error) {
                    console.log(d.error);
                    return [];
                } else {
                    //setPageCount(Math.ceil(d.total / itemsPerPage));
                    d.attendees = d.attendees.map((x: any) => {
                        x.timestamp = new Date(x.timestamp);
                        console.log(x.timestamp);
                        return x;
                    });
                    console.log(d);
                    setUpdating(false);
                    return d;
                }
            }
            setUpdating(false);
        },
    });

    // const getActionButtons = (item: any): JSX.Element => {
    //     if (item.status === "Pending") {
    //         return (
    //             <div style={{ display: "flex" }}>
    //                 <Tooltip content="Cancel Transaction" relationship="label">
    //                     <Button onClick={(e: any) => cancelPressed(e, item)} icon={<DeleteRegular />}></Button>
    //                 </Tooltip>
    //                 <Tooltip content="Confirm Transaction" relationship="label">
    //                     <Button onClick={(e: any) => checkmarkPressed(e, item)} icon={<CheckmarkRegular />}></Button>
    //                 </Tooltip>
    //             </div>
    //         );
    //     } else {
    //         return (
    //             <div style={{ display: "flex" }}>
    //                 <Tooltip content="Return to pending status" relationship="label">
    //                     <Button onClick={(e: any) => undoPressed(e, item)} icon={<ArrowUndoRegular />}></Button>
    //                 </Tooltip>
    //             </div>
    //         );
    //     }
    // };

    // const selectionChanged = (_e: React.MouseEvent | React.KeyboardEvent, data: any) => {
    //     console.log(data.selectedItems);
    //     setSelected(data.selectedItems);
    // };

    // const checkmarkPressed = async (e: React.MouseEvent<HTMLButtonElement, MouseEvent>, item: any) => {
    //     e.stopPropagation();
    //     setUpdating(true);
    //     let result = await updateItemAsync("Confirmed", item);
    //     if (result) {
    //         //update item in list
    //         queryClient.invalidateQueries({ queryKey: ["membersData"] });
    //     }
    //     setUpdating(false);
    // };

    // const cancelPressed = async (e: React.MouseEvent<HTMLButtonElement, MouseEvent>, item: any) => {
    //     e.stopPropagation();
    //     setUpdating(true);
    //     let result = await updateItemAsync("Removed by admin", item);
    //     if (result) {
    //         //update item in list
    //         queryClient.invalidateQueries({ queryKey: ["membersData"] });
    //     }
    //     setUpdating(false);
    // };

    // const undoPressed = async (e: React.MouseEvent<HTMLButtonElement, MouseEvent>, item: any) => {
    //     e.stopPropagation();
    //     setUpdating(true);
    //     let result = await updateItemAsync("Pending", item);
    //     if (result) {
    //         //update item in list
    //         queryClient.invalidateQueries({ queryKey: ["membersData"] });
    //     }
    //     setUpdating(false);
    // };

    // const updateItemAsync = async (status: string, item: any) => {
    //     if (accessTokenInfo$.value != null && accessTokenInfo$.value.accessToken != null) {
    //         //const userName = await firstValueFrom(userId$.pipe(filter(userId => userId != null && userId !== '')));
    //         let headers = new Headers();
    //         headers.append("Authorization", "Bearer " + accessTokenInfo$.value.accessToken);
    //         const res = await fetch(nodeServer + `transaction?status=${encodeURIComponent(status)}&id=${item.id}`, { method: "PUT", headers: headers });
    //         if (res.ok) {
    //             return true;
    //         }
    //     }
    //     return false;
    // };
    const columnSizingOptions : TableColumnSizingOptions = {
        timestamp: {
            idealWidth: 80,
        },
        first: {
            idealWidth: 70,
        },
        last: {
            idealWidth: 70,
        },
        // email: {
        //     idealWidth: 70,
        // },
        accomodations: {
            idealWidth: 100,
        },
        mealpref: {
            idealWidth: 80,
        },
        mealprefplus: {
            idealWidth: 80,
        },
        mealpref2: {
            idealWidth: 100,
        },
    };

    const columns: TableColumnDefinition<IConferenceAttendee>[] = [
        createTableColumn<IConferenceAttendee>({
            columnId: "timestamp",
            renderHeaderCell: () => "Last Edit Date",
            renderCell: (item) => <TableCellLayout style={{ overflowX: "hidden", width: "50px" }}>{item.timestamp?.toLocaleDateString()}</TableCellLayout>,
            compare: (a, b) => (a.id && b.id ? a.id - b.id : 0),
        }),
        createTableColumn<IConferenceAttendee>({
            columnId: "first",
            renderHeaderCell: () => "First",
            renderCell: (item) => <TableCellLayout style={{ overflowX: "hidden" }}>{item.first}</TableCellLayout>,
            compare: (a, b) => a.first.localeCompare(b.first),
        }),
        createTableColumn<IConferenceAttendee>({
            columnId: "last",
            renderHeaderCell: () => "Last",
            renderCell: (item) => <TableCellLayout style={{ overflowX: "hidden" }}>{item.last}</TableCellLayout>,
            compare: (a, b) => a.last.localeCompare(b.last),
        }),
        createTableColumn<IConferenceAttendee>({
            columnId: "email",
            renderHeaderCell: () => "Email",
            renderCell: (item) => <TableCellLayout style={{ overflowX: "hidden", overflowWrap: "break-word", whiteSpace:"normal" }}>{item.email}</TableCellLayout>,
            compare: (a, b) => a.email.localeCompare(b.email),
        }),

        createTableColumn<IConferenceAttendee>({
            columnId: "accomodations",
            renderHeaderCell: () => "Accomodations?",
            renderCell: (item) => <TableCellLayout style={{ overflowX: "hidden" }}>{(item.details! as IRegistrationOption[])[0].value}</TableCellLayout>,
            compare: (a, b) => ((a.details! as IRegistrationOption[])[0].value as string).localeCompare((b.details! as IRegistrationOption[])[0].value as string),
        }),
        createTableColumn<IConferenceAttendee>({
            columnId: "mealpref",
            renderHeaderCell: () => "Dietary Requirements",
            renderCell: (item) => <TableCellLayout style={{ overflowX: "hidden" }}>{(item.details! as IRegistrationOption[])[1].value}</TableCellLayout>,
            compare: (a, b) => ((a.details! as IRegistrationOption[])[1].value as string).localeCompare((b.details! as IRegistrationOption[])[1].value as string),
        }),
        createTableColumn<IConferenceAttendee>({
            columnId: "mealprefplus",
            renderHeaderCell: () => "Dietary Requirements OTHER",
            renderCell: (item) => <TableCellLayout style={{ overflowX: "hidden" }}>{(item.details! as IRegistrationOption[])[1].value2}</TableCellLayout>,
            //compare: (a, b) => ((a.details! as IRegistrationOption[])[1].value2 as string).localeCompare((b.details! as IRegistrationOption[])[1].value2 as string),
        }),
        createTableColumn<IConferenceAttendee>({
            columnId: "mealpref2",
            renderHeaderCell: () => "Boxed Lunch",
            renderCell: (item) => <TableCellLayout style={{ overflowX: "hidden" }}>{(item.details! as IRegistrationOption[])[2].value}</TableCellLayout>,
            compare: (a, b) => ((a.details! as IRegistrationOption[])[2].value as string).localeCompare((b.details! as IRegistrationOption[])[2].value as string),
        }),
        createTableColumn<IConferenceAttendee>({
            columnId: "activities",
            renderHeaderCell: () => "Activities",
            renderCell: (item) => {
                return (
                    <TableCellLayout style={{ overflowX: "hidden" }}>
                        {((item.details! as IRegistrationOption[])[3].value as string[])
                            .map((v) => {
                                //v = v.substring(0, 8);
                                return v;
                            })
                            .join(", ")}
                    </TableCellLayout>
                );
            },
            //compare: (a, b) => ((a.details! as IRegistrationOption[])[2].value as string).localeCompare((b.details! as IRegistrationOption[])[2].value as string),
            //compare: (a, b) => a.item.localeCompare(b.item)
        }),
    ];

    // useEffect(()=>{
    //     if (attendeeData !== undefined) {
    //         var moreColumns = attendeeData?.conference?.data?.registrationOptions.map((x:IRegistrationOption, i:number) => {
    //             console.log(x.name);
    //             createTableColumn<IConferenceAttendee>({
    //                  columnId: x.name,
    //                  renderHeaderCell: () => x.name,
    //                  //renderCell: (item) => (<TableCellLayout style={{ overflowX: 'hidden' }} >{item[x.name]}</TableCellLayout>),
    //                  //compare: (a, b) => a.details![i][x.name].localeCompare(b.details![i][x.name])
    //             });
    //         });
    //         //columns.push(...moreColumns);
    //     }

    // },[attendeeData]);

    const getCellFocusMode = (columnId: TableColumnId): DataGridCellFocusMode => {
        switch (columnId) {
            case "action":
                return "group";
            default:
                return "cell";
        }
    };

    // const searchId = useId("searchbox");

    // const onSearchChange: SearchBoxProps["onChange"] = (_ev: any, data: any) => {
    //     //if (data.value.length <= 20) {
    //     setSearchValue(data.value);
    //     if (data.value.trim().length === 0 && searchTerm.length > 0) {
    //         setSearchTerm("");
    //     }
    //     //setValid(true);
    //     //} else {
    //     //setValid(false);
    //     //}
    // };
    // const onSearchKeyDown: InputProps["onKeyDown"] = (ev: any) => {
    //     if (ev.key === "Enter" && searchValue.trim().length > 0) {
    //         //do search
    //         console.log(searchValue.trim());
    //         setSearchTerm(searchValue.trim().toLocaleLowerCase());
    //     }
    // };

    const generalStyles = useGeneralStyles();

    // useEffect(() => {
    //     if (attendeeData && attendeeData.attendees && attendeeData.attendees.length > 0)
    //         setSummaryOption(0);
    // }, [attendeeData]);

    const [summaryOption, setSummaryOption] = useState<number>(0);
    const createTable = () => {
        if (summaryOption === -1) return <></>;
        const regOption = attendeeData!.conference!.data!.registrationOptions![summaryOption];

        let headerRow: () => JSX.Element[] = () => [<TableHeaderCell key={"headersummary"}>{regOption.name}</TableHeaderCell>];

        let bodyRows: () => JSX.Element[] = () => [<TableRow key={"bodysummary"}>TEST</TableRow>];

        switch (regOption.optionType) {
            case RegistrationOptionType.text:
                const summary: Map<string, number> | undefined = attendeeData?.attendees.reduce((acc, curr) => {
                    let response = (curr.details as IRegistrationOption[])[summaryOption].value as string;
                    if (response === undefined) return acc;
                    response = response.trim();
                    response = response.toLocaleLowerCase();
                    if (acc.has(response)) {
                        acc.set(response, acc.get(response)! + 1);
                    } else {
                        acc.set(response, 1);
                    }
                    return acc;
                }, new Map<string, number>());
                if (summary === undefined) return <></>;
                const summaryMap = new Array(...summary).map(([k, v]) => ({ answer: k, answercount: v }));

                headerRow = () => [<TableHeaderCell key={"answer"}>Answer</TableHeaderCell>, <TableHeaderCell key={"answercount"}>Frequency</TableHeaderCell>];
                bodyRows = () => {
                    return summaryMap.map((v) => (
                        <TableRow key={v.answer}>
                            <TableCell key={v.answer + "answer"}>{v.answer}</TableCell>
                            <TableCell key={v.answer + v.answercount}>{v.answercount}</TableCell>
                        </TableRow>
                    ));
                };
                break;
            case RegistrationOptionType.choice:
                const containsOther = (regOption.options! as string[]).includes("Other");
                if (containsOther) {
                    headerRow = () => {
                        const headerElements = regOption.options!.map((v) => <TableHeaderCell key={v}>{v}</TableHeaderCell>);
                        headerElements.push(<TableHeaderCell key={"othervaluesheader"}>Other Values</TableHeaderCell>);
                        return headerElements;
                    };
                    bodyRows = () => {
                        let counts = regOption.options!.map((option) => {
                            return attendeeData?.attendees //.map(attendee=> (attendee.details as hIRegistrationOption[])![summaryOption].value === option ? 1 : 0)
                                .reduce((acc, curr) => {
                                    //console.log((curr.details as IRegistrationOption[])[summaryOption].name);
                                    return acc + ((curr.details as IRegistrationOption[])[summaryOption].value === option ? 1 : 0);
                                }, 0);
                        });
                        let bodyCells = counts.map((v, i) => <TableCell key={i + "summary"}>{v}</TableCell>);
                        const otherSummary = attendeeData?.attendees
                            .filter((v) => (v.details! as IRegistrationOption[])[summaryOption].value === "Other")
                            .map((v) => {
                                return (v.details! as IRegistrationOption[])[summaryOption].value2;
                            })
                            .join("<br/ >");
                        bodyCells.push(
                            <TableCell key={"othervaluesbody"}>
                                <div dangerouslySetInnerHTML={{ __html: otherSummary as string }} />
                            </TableCell>
                        );

                        return [<TableRow key={"choice"}>{bodyCells}</TableRow>];
                    };
                } else {
                    headerRow = () => regOption.options!.map((v) => <TableHeaderCell key={v}>{v}</TableHeaderCell>);
                    bodyRows = () => {
                        let counts = regOption.options!.map((option) => {
                            return attendeeData?.attendees //.map(attendee=> (attendee.details as hIRegistrationOption[])![summaryOption].value === option ? 1 : 0)
                                .reduce((acc, curr) => {
                                    //console.log((curr.details as IRegistrationOption[])[summaryOption].name);
                                    return acc + ((curr.details as IRegistrationOption[])[summaryOption].value === option ? 1 : 0);
                                }, 0);
                        });

                        return [
                            <TableRow key={"choice"}>
                                {counts.map((v, i) => (
                                    <TableCell key={i + "summary"}>{v}</TableCell>
                                ))}
                            </TableRow>,
                        ];
                    };
                }

                break;
            case RegistrationOptionType.choiceDetails:
                headerRow = () => regOption.options!.map((v) => <TableHeaderCell key={v.main}>{v.main}</TableHeaderCell>);
                bodyRows = () => {
                    let counts = regOption.options!.map((option) => {
                        return attendeeData?.attendees //.map(attendee=> (attendee.details as IRegistrationOption[])![summaryOption].value === option ? 1 : 0)
                            .reduce((acc, curr) => {
                                return acc + ((curr.details as IRegistrationOption[])[summaryOption].value === option.main ? 1 : 0);
                            }, 0);
                    });

                    return [
                        <TableRow key={"choicedetails"}>
                            {counts.map((v, i) => (
                                <TableCell key={i + "summary"}>{v}</TableCell>
                            ))}
                        </TableRow>,
                    ];
                };
                break;
            case RegistrationOptionType.choiceMultiselect:
                headerRow = () => regOption.options!.map((v) => <TableHeaderCell key={v}>{v}</TableHeaderCell>);
                bodyRows = () => {
                    let counts = regOption.options!.map((option) => {
                        return attendeeData?.attendees //.map(attendee=> (attendee.details as IRegistrationOption[])![summaryOption].value === option ? 1 : 0)
                            .reduce((acc, curr) => {
                                return acc + (((curr.details as IRegistrationOption[])[summaryOption].value as string[]).includes(option) ? 1 : 0);
                            }, 0);
                    });

                    return [
                        <TableRow key={"choicedetails"}>
                            {counts.map((v, i) => (
                                <TableCell key={i + "summary"}>{v}</TableCell>
                            ))}
                        </TableRow>,
                    ];
                };
                break;
        }
        return (
            <Table style={{ width:'100%' }}>
                <TableHeader>
                    <TableRow>{headerRow()}</TableRow>
                </TableHeader>
                <TableBody>{bodyRows()}</TableBody>
            </Table>
        );
    };
    const dropdownId = useId("dropdown-summary");

    const getNodeText = node => {
        if (['string', 'number'].includes(typeof node)) return node
        if (node instanceof Array) return node.map(getNodeText).join('')
        if (typeof node === 'object' && node) return getNodeText(node.props.children)
      }

    const outputAsCsv = () => {
        if (attendeeData === undefined) return;
        console.log("outputting as csv");

        const output: string[] = [];
        let row :string[]= [];
        columns.forEach((column) => {            
            const cell = column.renderHeaderCell();
            let content:string = getNodeText(cell);
            if (content && (content.includes('"') || content.includes(",") || content.includes("\n"))) {
                content = "\"" + content + "\"";
            }
            row.push(content);
        });
        output.push(row.join(","));
        attendeeData.attendees.forEach((attendee) => {
            let row :string[]= [];
            columns.forEach((column) => {
                const cell = column.renderCell(attendee);
                let content:string = getNodeText(cell);
                if (content && (content.includes('"') || content.includes(",") || content.includes("\n"))) {
                    content = "\"" + content + "\"";
                }
                row.push(content);
            });
            output.push(row.join(","));
        });


        const blob = new Blob([output.join('\n')], { type: "text/csv" });
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        const today = new Date();
        link.setAttribute("download", `AttendeeData${today.getUTCFullYear() + "-" + (today.getMonth() + 1).toString() + "-" + today.getDate()}.csv`);

        // Append to html link element page
        document.body.appendChild(link);

        // Start download
        link.click();

        // Clean up and remove the link
        link.parentNode!.removeChild(link);
    };

    return (
        <>
            {authorized ? (
                <div style={{ marginBottom: "20px", position: "relative",
                 display: "flex", flexDirection: "column", flex:'0 0 100%',
                 boxSizing: "border-box", 
                 width: "100%" }}>
                    {/* <div style={{position: 'flex', width:'100%', overflow:'none'}}> */}
                        <Text className={generalStyles.groupTitle}>Conference Attendee Data</Text>
                        {attendeeData && attendeeData.conference && (
                            <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
                                <Label htmlFor={dropdownId}>Summary</Label>
                                <Dropdown
                                    style={{ width: "200px" }}
                                    id={dropdownId}
                                    value={attendeeData!.conference!.data!.registrationOptions![summaryOption].name}
                                    placeholder="choose for summary..."
                                    onOptionSelect={(_, data) => {
                                        data.optionValue ? setSummaryOption(+data.optionValue) : setSummaryOption(-1);
                                    }}
                                >
                                    {attendeeData!.conference!.data!.registrationOptions!.map((x: IRegistrationOption, i: number) => (
                                        <Option key={i} value={i.toString()}>
                                            {x.name}
                                        </Option>
                                    ))}
                                </Dropdown>
                                {
                                createTable()
                                }
                            </div>
                        )}
                        <div style={{ display: "flex", flexDirection: "row", alignItems: "flex-end", gap: "10px", marginBottom: "10px", width: "100%" }}>
                            <Button onClick={() => outputAsCsv()} appearance="primary">
                                Download Raw Data as CSV
                            </Button>
                            {/* <Button onClick={approveAllPressed} disabled={selected.size > 0 ? false : true}>Confirm Selected</Button> */}
                            {/* <div style={{ display: "flex", flexDirection: "column" }}>
                            <Label htmlFor={searchId}>Search</Label>
                            <SearchBox id={searchId} onKeyDown={onSearchKeyDown} placeholder="name..." value={searchValue} onChange={onSearchChange} />
                        </div> */}
                        </div>
                        {/* <Pagination pageCount={pageCount} selectedPageIndex={page} onPageChange={handlePageChange}
                        format={'buttons'}
                        previousPageAriaLabel={'previous page'}
                        nextPageAriaLabel={'next page'}
                        firstPageAriaLabel={'first page'}
                        lastPageAriaLabel={'last page'}
                        pageAriaLabel={'page'}
                        selectedAriaLabel={'selected'} /> */}
                        <div style={{ overflowX: "hidden", width: "100%" , position:'static'}}>
                            {attendeeData !== undefined && (
                                <div style={{ overflowX: "scroll",  }}>
                                    <DataGrid items={attendeeData.attendees} 
                                    
                                    columns={columns} sortable selectionMode="single" 
                                    size="small" focusMode="cell" resizableColumns 
                                    resizableColumnsOptions={{autoFitColumns:false}}
                                    columnSizingOptions={columnSizingOptions}>
                                        <DataGridHeader>
                                            <DataGridRow selectionCell={{ "aria-label": "Select all rows" }}>{({ renderHeaderCell }) => <DataGridHeaderCell>{renderHeaderCell()}</DataGridHeaderCell>}</DataGridRow>
                                        </DataGridHeader>
                                        <DataGridBody<any>>
                                            {({ item, rowId }) => (
                                                <DataGridRow<any> key={rowId} selectionCell={{ "aria-label": "Select row" }}>
                                                    {({ renderCell, columnId }) => <DataGridCell focusMode={getCellFocusMode(columnId)}>{renderCell(item)}</DataGridCell>}
                                                </DataGridRow>
                                            )}
                                        </DataGridBody>
                                    </DataGrid>
                                </div>
                            )}
                        </div>
                        {(isFetching || updating) && (
                            <div style={{ background: `var(--colorBackgroundOverlay)`, position: "absolute", top: 0, bottom: 0, left: 0, right: 0 }}>
                                <Spinner style={{ position: "absolute", top: 0, bottom: 0, left: 0, right: 0 }} label="Loading..." size="large" />
                            </div>
                        )}
                    </div>
                // </div>
            ) : (
                <Text className={generalStyles.groupTitle}>You are not authorized to view this page.</Text>
            )}
        </>
    );
};

export default AttendeeData;
